import * as Yup from 'yup';
import { SarlaftStateCase } from '../../../../../../shared/types/modules/sarlaft';

export const initialValues: SarlaftStateCase = {
    caseStatus: '',
    observation: '',
};

export const validationSchema = Yup.object({
    caseStatus: Yup.string().required('El estado del caso obligatorio'),
    observation: Yup.string(),
});
